<div class="job-topbar">
  <a href="/">
    <img src="assets/imgs/Zumeralogo-WHITE.png" alt="Zumera" class="job-topbar__logo" />
  </a>
</div>

<!-- Loading State -->
@if (isLoading) {
  <div class="container py-5 text-center" style="margin-top: 88px;">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-3">Loading job details...</p>
  </div>
}

<!-- Error State -->
@if (error && !isLoading) {
  <div class="container py-5" style="margin-top: 88px;">
    <div class="alert alert-danger" role="alert">
      <h4 class="alert-heading">{{ error }}</h4>
      <p>The job listing you're looking for might have been removed or is temporarily unavailable.</p>
      <hr>
        <a routerLink="/join-our-tribe" class="btn btn-primary">View All Jobs</a>
      </div>
    </div>
  }

  <!-- Job Content -->
  @if (!isLoading && !error && job) {
    <div class="job-container">
      <div class="job-inner">
        <div class="job-card-main">
          <div class="job-header">
            <a (click)="goBack()" class="back-link" style="cursor: pointer;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M15 18l-6-6 6-6"/>
              </svg>
              Job Openings
            </a>
            <h1 class="job-title">{{job.title}}</h1>
            <p class="job-subtitle">{{job.location}}</p>
            <div class="separator mt-4"></div>
          </div>
          <div class="job-body">
            @if (job.companyDescription) {
              <div class="section-block">
                <h2>Zumera Property</h2>
                <div [innerHTML]="job.companyDescription"></div>
              </div>
            }
            @if (job.roleSummary) {
              <div class="section-block mt-5">
                <h2>Role Summary</h2>
                <p>{{job.roleSummary}}</p>
              </div>
            } @else if (job.description) {
              <div class="section-block mt-5">
                <h2>Job Description</h2>
                <p>{{job.description}}</p>
              </div>
            }
            @if (!job.isExecutive) {
              <div class="section-block mt-5">
                <h2>Requirements:</h2>
                <div class="requirement-group mt-4">
                  <h3>General Requirement</h3>
                  <ul class="styled-list">
                    <li>All roles are full-time and on-site; applicants must be available to work from the designated location.</li>
                    <li>Applicants must complete the mandatory online application and pre-screening form, which includes submission of a Letter of Intent (maximum 500 words).</li>
                  </ul>
                  <p class="mt-3 mb-3"><strong>Please note: The final paragraph of the letter must include a referee's profile, full name, phone number, and email address. The referee is not limited to any specific relationship.</strong></p>
                  <ul class="styled-list">
                    <li>Candidates must be available for virtual interviews and assessments as part of a multi-stage selection process.</li>
                    <li>Final-stage candidates must be willing to travel for in-person interviews where required.</li>
                    <li>Successful applicants will undergo a 3-month probation period focused on performance and culture fit.</li>
                    <li>Only candidates who meet all requirements will be contacted at each stage.</li>
                  </ul>
                </div>
              </div>
            }
            @if (job.responsibilities?.length) {
              <div class="section-block mt-5">
                <h2>Key Responsibilities</h2>
                <ul class="styled-list">
                  @for (res of job.responsibilities; track res) {
                    <li>{{res}}</li>
                  }
                </ul>
              </div>
            }
            @if (job.qualifications?.length) {
              <div class="section-block mt-5">
                <h2>{{ job.isExecutive ? 'Qualification & Experience' : 'Qualification' }}</h2>
                <ul class="styled-list">
                  @for (qual of job.qualifications; track qual) {
                    <li>{{qual}}</li>
                  }
                </ul>
              </div>
            }
          </div>
        </div>
        <div class="job-sidebar-area">
          @if (job) {
            <app-job-sidebar [job]="job"></app-job-sidebar>
          }
        </div>
      </div>
    </div>
  }


  <div class="modal fade" id="applyModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <h3 class="text-center pt-5">Fill the Job Application</h3>
        <form class="row g-3 p-3 " #applicationForm="ngForm">
          <div class="col-12">
            <label for="jobTitle" class="form-label">Job Title</label>
            <input [ngModel]="jobTitle" name="jobTitle" type="text" class="form-control" id="jobTitle" disabled>
          </div>

          <div class="col-12">
            <label for="fullName" class="form-label">Full Name</label>
            <input ngModel name="name" type="text" class="form-control" id="fullName">
          </div>

          <div class="col-12">
            <label for="inputEmail4" class="form-label">Email</label>
            <input ngModel name="email" type="email" class="form-control" id="inputEmail4">
          </div>

          <div class="col-12">
            <label for="inputAddress" class="form-label">Address</label>
            <input ngModel name="address" type="text" class="form-control" id="inputAddress" placeholder="First east circular road">
          </div>

          <div class="col-12">
            <label for="dateOfBirth" class="form-label">Date of Birth</label>
            <input ngModel name="dob" type="date" class="form-control" id="dateOfBirth">
          </div>

          <div class="col-12">
            <label for="experience" class="form-label">How many years of experience do you have?</label>

            <select [(ngModel)]="experienceValue" name="experience" class="form-select form-select-sm" aria-label="Small select example">
              <option value="">-- select experience --</option>
              <option value="1-2">1-2</option>
              <option value="2-4">2-4</option>
              <option value="4+">4+</option>
            </select>
          </div>

          <div class="col-12">
            <div class=" mb-3">
              <label class="form-label" for="inputGroupFile01">Upload your CV</label>
              <input ngModel name="pdfFile" type="file" class="form-control" id="inputGroupFile01">
            </div>
          </div>

          <div class="col-12">
            <div class=" ">
              <label for="floatingTextarea2">Cover Letter</label>

              <textarea ngModel name="letter" class="form-control" placeholder="Leave a comment here" id="floatingTextarea2" style="height: 100px"></textarea>
            </div>
          </div>



          <div class="col-12">
            <button type="submit" class="btn z-full-red "  (click)="onSubmitApplication(applicationForm)">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>


  <app-figma-benin-footer></app-figma-benin-footer>